import { Component } from '@angular/core';
import { HeaderComponent } from '../_shared/header/header.component';
import { NavmenuComponent } from '../_shared/navmenu/navmenu.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-authenticated-layout',
    templateUrl: './authenticated-layout.component.html',
    styleUrls: ['./authenticated-layout.component.css'],
    imports: [HeaderComponent, NavmenuComponent, RouterOutlet]
})
export class AuthenticatedLayoutComponent { }
